/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Days_Per_Week_LongInputs */

const en_us2_intake_why_days_per_week_long = /** @type {(inputs: Intake_Why_Days_Per_Week_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two or three days is full body; four or more splits the body across days.`)
};

const pt_br2_intake_why_days_per_week_long = /** @type {(inputs: Intake_Why_Days_Per_Week_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois ou três dias é corpo inteiro; quatro ou mais divide o corpo pelos dias.`)
};

const es_419_intake_why_days_per_week_long = /** @type {(inputs: Intake_Why_Days_Per_Week_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos o tres días es cuerpo completo; cuatro o más dividen el cuerpo entre los días.`)
};

const pt_pt2_intake_why_days_per_week_long = /** @type {(inputs: Intake_Why_Days_Per_Week_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois ou três dias é corpo inteiro; quatro ou mais divide o corpo pelos dias.`)
};

const fr_fr2_intake_why_days_per_week_long = /** @type {(inputs: Intake_Why_Days_Per_Week_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux ou trois jours, c'est du corps entier ; à partir de quatre, le corps est réparti sur les jours.`)
};

const de_de2_intake_why_days_per_week_long = /** @type {(inputs: Intake_Why_Days_Per_Week_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei oder drei Tage sind Ganzkörper; ab vier wird der Körper auf die Tage aufgeteilt.`)
};

const it_it2_intake_why_days_per_week_long = /** @type {(inputs: Intake_Why_Days_Per_Week_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due o tre giorni significa total body; quattro o più dividono il corpo nei vari giorni.`)
};

/**
* | output |
* | --- |
* | "Two or three days is full body; four or more splits the body across days." |
*
* @param {Intake_Why_Days_Per_Week_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_days_per_week_long = /** @type {((inputs?: Intake_Why_Days_Per_Week_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Days_Per_Week_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_days_per_week_long(inputs)
	if (locale === "es-419") return es_419_intake_why_days_per_week_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_days_per_week_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_days_per_week_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_days_per_week_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_days_per_week_long(inputs)
	return en_us2_intake_why_days_per_week_long(inputs)
});
export { intake_why_days_per_week_long as "intake.why.days_per_week.long" }